(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PatientMedicationTakeMissedReason', PatientMedicationTakeMissedReason);

    PatientMedicationTakeMissedReason.$inject = ['$resource'];

    function PatientMedicationTakeMissedReason ($resource) {
        var resourceUrl =  'api/patient-medication-take-missed-reasons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/patient-medication-take-missed-reasons/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
